"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ExpandableContent = require("../../../ExpandableContent");

var _Typography = require("../../Typography");

var _ActionIconItem = _interopRequireDefault(require("./ActionIconItem"));

var _SidebarLink = _interopRequireDefault(require("./SidebarLink"));

var _arrowRight = _interopRequireDefault(require("../../../assets/images/arrow-right.svg"));

var _Constant = require("../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-bottom: 1px solid ", ";\n  display: block;\n  height: 7.4rem;\n  outline: none;\n  text-decoration: none;\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    outline: 4px solid ", ";\n    outline-offset: -4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var A = (0, _styledComponents.default)(_SidebarLink.default)(_templateObject(), _Constant.Color.GREY_2, _Constant.Color.FOCUS_B);

var SidebarLinkItem = function SidebarLinkItem(_ref) {
  var actionIcon = _ref.actionIcon,
      isRouterLink = _ref.isRouterLink,
      label = _ref.label,
      marketingIcon = _ref.marketingIcon,
      to = _ref.to,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["actionIcon", "isRouterLink", "label", "marketingIcon", "to"]);
  return /*#__PURE__*/_react.default.createElement(A, (0, _extends2.default)({
    isRouterLink: isRouterLink,
    to: to
  }, rest), /*#__PURE__*/_react.default.createElement(_ExpandableContent.SummaryHeading, {
    as: _Typography.Typography.SidebarHeader,
    padding: "13px 15px"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: marketingIcon,
    alt: "",
    "data-testid": "marketing-icon"
  }), /*#__PURE__*/_react.default.createElement(_ExpandableContent.SummaryText, null, label), /*#__PURE__*/_react.default.createElement(_ActionIconItem.default, {
    actionIcon: actionIcon == null ? _arrowRight.default : actionIcon
  })));
};

SidebarLinkItem.propTypes = {
  /** Customizable icon that indicates this section is a link and is not expandable/collapsible */
  actionIcon: _propTypes.default.string,

  /** Renders a React Router Link so page will not refresh */
  isRouterLink: _propTypes.default.bool,

  /** The link text */
  label: _propTypes.default.string.isRequired,

  /** Icon that appears to the left of the `label` text */
  marketingIcon: _propTypes.default.string.isRequired,

  /** The URL assigned to the `to` attribute on a React Router Link or to the `href` on a regular link.
   * When using the default HTML anchor element, to should be passed a string.
   * When using isRouterLink, to can be a string, an object, or a function that returns a string or object.
   */
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
};
SidebarLinkItem.defaultProps = {
  actionIcon: null,
  isRouterLink: false,
  to: null
};
var _default = SidebarLinkItem;
exports.default = _default;